import { ChatAssistantFilter } from '../../../../shared/types/chat-assistant';

export const initialValues: ChatAssistantFilter = {
    name: '',
    description: '',
    initialConfiguration: '',
    project: '',
};
